<!-- name: IM 弹窗 -->
<!-- demo:
import IMDialog from 'src/views/about/pages/index/components/IMDialog.vue';

<IMDialog ref="IMDialogRef"/>

this.$refs.IMDialogRef.open({ reload, contactId, resourceId, requirementId });
 -->
<template>
  <div
    v-if="visible"
    class="im"
  >
    <div class="close-box" @click="handleClosed">
      <IconSvg name="pc-common-icon-ic_closeone" class="close-icon"/>
    </div>
    <!-- 加 :key="url" 是为了不复用 iframe -->
    <Iframe ref="iframeRef" :key="url" :src="url"/>
  </div>
</template>

<script>
import { isNotEmpty } from '@lhb/func';
import { getCookie } from '@lhb/cache';
import Iframe from 'src/common/components/Iframe/index.vue';
import { getStorage } from '@lhb/cache';
import IconSvg from 'src/common/components/Iconfont/IconSvg.vue';

export default {
  name: 'IMModal',
  components: {
    Iframe,
    IconSvg
  },

  data() {
    return {
      visible: false,

      title: '',
    };
  },

  computed: {
    url() {
      const token = getCookie('newPmsToken') || getStorage('newPmsToken');
      const url = process.env.IM_URL;
      return `${url}/#/home?source=pms&token=${token}&consultation_type=6&timestamp=${Math.random()}&mode=pc`;
    }
  },

  mounted() {
    window.addEventListener('message', this.receiveImMessageHandler, false);
  },

  methods: {

    isNotEmpty,

    receiveImMessageHandler({ data: { type, data }}) {
      if (type === 'spotDetail' && data) {
        window.open(`/lhb-micro-pms/pointMng/detail?tenantSpotId=${data}`);
      }
    },

    open() {
      this.visible = true;
    },

    // 关闭弹窗
    handleClosed() {
      this.visible = false;
    }

  },
};
</script>

<style lang="scss" type="text/scss" scoped>
.im {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 680px;
  height: 600px;
  z-index: 10000;
  box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);
  .close-box {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: #FFFFFF;
    position: absolute;
    top: 10px;
    left: -32px;
    box-shadow: -5px 5px 10px rgba(0,0,0,0.1);
    .close-icon {
      color: #86909C;
    }
  }
}
</style>
